__turbopack_context__.v({
  "description": "style-module-scss-module__W9cs6a__description",
  "img": "style-module-scss-module__W9cs6a__img",
  "link": "style-module-scss-module__W9cs6a__link",
  "price": "style-module-scss-module__W9cs6a__price",
  "product": "style-module-scss-module__W9cs6a__product",
  "products": "style-module-scss-module__W9cs6a__products",
  "root": "style-module-scss-module__W9cs6a__root",
  "title": "style-module-scss-module__W9cs6a__title",
});
